var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cutText } from '../../../../utils/text';
import { AssignmentDay } from '../../../ActivityDay/AssignmentDay';
import { EducationalDay } from '../../../ActivityDay/EducationalDay';
import { TestDay } from '../../../ActivityDay/TestDay';
import { TableDaysRow } from '../../../Common';
var ASSIGNMENT_NAME_MAX_LENGTH = 18;
var ActivityWeekCells = function (_a) {
    var days = _a.days, activityCalendar = _a.activityCalendar, isModalOpen = _a.isModalOpen, toggleModal = _a.toggleModal;
    return (_jsx(TableDaysRow, { children: days.map(function (_a) {
            var _b;
            var weekDay = _a.day;
            var activity = activityCalendar.find(function (x) { return x.date === weekDay; });
            if (activity) {
                var hasTest = Boolean(activity.assessments && activity.assessments.length > 0);
                var hasAssignmentTests = ((_b = activity === null || activity === void 0 ? void 0 : activity.assignments) === null || _b === void 0 ? void 0 : _b.length) > 0;
                if (hasTest) {
                    var _c = activity.assessments[activity.assessments.length - 1], type = _c.type, status_1 = _c.status;
                    return (_jsx(TestDay, { isModalOpen: isModalOpen, type: type, status: status_1, contentProps: { activity: activity, toggleModal: toggleModal } }, type));
                }
                if (hasAssignmentTests) {
                    var assignments = activity.assignments;
                    var assignmentsWithShortenNames = assignments.map(function (assignment) { return (__assign(__assign({}, assignment), { name: cutText(assignment.name, ASSIGNMENT_NAME_MAX_LENGTH) })); });
                    return (_jsx(AssignmentDay, { assignments: assignmentsWithShortenNames, practiceTime: activity.timeSpent, isModalOpen: isModalOpen }, activity.date));
                }
            }
            return _jsx(EducationalDay, { timeSpent: activity === null || activity === void 0 ? void 0 : activity.timeSpent }, weekDay);
        }) }, void 0));
};
export { ActivityWeekCells };
